import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getPortInAvailability } from '../../../actions/Inteliquent';
import LocationForm from './LocationForm';
import { streetDirOptions, typeOfServiceOptions } from './constant';
import { STATE_OPTIONS, PROVINCE_OPTIONS, COUNTRY_LIST } from '../../../utils/constants';

export default function NumberForm({ id, ...props }) {
  const token = localStorage.getItem('jwtToken') || null;
  const dispatch = useDispatch();
  const { form, index, fields, extraTnOptions } = props;
  const {
    register,
    formState: { errors: formErrors },
    setValue,
  } = form;
  const formname = `tnItem.${index}`;
  const errors = formErrors?.tnItem && formErrors?.tnItem[index];
  const [tnOptions, setTnOptions] = useState(extraTnOptions);
  const [country, setCountry] = useState(COUNTRY_LIST[0]);
  const [stateOrProvince, setStateOrProvince] = useState({ label1: 'State', label2: 'Zip Code', value: STATE_OPTIONS || [] });

  const numberaddinputref = useRef();
  const stateCodes = useSelector(state => state.UIState.proposalEditor.stateCodes);

  useEffect(() => setTnOptions(extraTnOptions), [extraTnOptions]);

  const handleSelectCountry = e => {
    if (e.target.value !== null) {
      setCountry(e.target.value);
      setStateOrProvince({
        label1: e.target.value === COUNTRY_LIST[0] ? 'State' : 'Province',
        label2: e.target.value === COUNTRY_LIST[0] ? 'Zip Code' : 'Postal Code',
        value: e.target.value === COUNTRY_LIST[0] ? STATE_OPTIONS : PROVINCE_OPTIONS,
      });
    }
  };

  const isValidCanadianProvince = (postalCode) => {
    // Define a regular expression pattern for ANA NAN format
    const regex = /^[A-Za-z]\d[A-Za-z]\s\d[A-Za-z]\d$/;
  
    // Use the test() method to check if the postalCode matches the pattern
    return regex.test(postalCode);
  }

  const isValidUSZIPCode = (zipcode) => {
    // Define a regular expression pattern for both 5-digit and 9-digit ZIP codes
    const regex = /^\d{5}(-\d{4})?$/;
  
    // Use the test() method to check if the input matches the pattern
    return regex.test(zipcode);
  }

  return (
    <div>
      {id && <h5 className="font-weight-bolder">Number{fields?.tn} Detail</h5>}
      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">Authorized Name*</span>
        <input
          className="form-control"
          defaultValue={fields.authName}
          {...register(`${formname}.authName`, { required: 'This is required' })}
          type="text"
        />
        {errors?.authName && (
          <div className="text-danger font-weight-bold">{errors?.authName?.message}</div>
        )}
      </label>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">Authorized Date*</span>
        <input
          min={`${moment(fields.authDate)
            .subtract(30, 'days')
            .format('YYYY-MM-DD')}`}
          className="form-control"
          defaultValue={fields.authDate}
          {...register(`${formname}.authDate`, {
            required: 'This is required',
            validate: val => {
              const value = moment(val);
              return (
                value.diff(moment().format('YYYY-MM-DD'), 'day') <= 0 ||
                'Desired Date Cannot Be in Future'
              );
            },
          })}
          type="date"
        />
        {errors?.authDate && (
          <div className="text-danger font-weight-bold">{errors?.authDate?.message}</div>
        )}
      </label>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">Account Number*</span>
        <input
          className="form-control"
          defaultValue={fields.accountNum}
          {...register(`${formname}.accountNum`, { required: 'This is required' })}
          type="number"
        />
        {errors?.accountNum && (
          <div className="text-danger font-weight-bold">{errors?.accountNum?.message}</div>
        )}
      </label>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">Account Pin/Password</span>
        <input
          className="form-control"
          defaultValue={fields.accountPin}
          {...register(`${formname}.accountPin`)}
          type="password"
        />
        {errors?.accountPin && (
          <div className="text-danger font-weight-bold">{errors?.accountPin?.message}</div>
        )}
      </label>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">
          Billing Telephone Number (BTN/ATN)*
        </span>
        <input
          className="form-control"
          defaultValue={fields.atn}
          {...register(`${formname}.atn`, {
            required: 'This is required',
            minLength: 10,
            maxLength: 10,
          })}
          type="text"
        />
        {errors?.atn?.message ? (
          <div className="text-danger font-weight-bold">{errors?.atn?.message}</div>
        ) : (
          (errors?.atn?.type === 'maxLength' || errors?.atn?.type === 'minLength') && (
            <div className="text-danger font-weight-bold">BTN/ATN Should be of 10 length</div>
          )
        )}
      </label>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">End User Name*</span>
        <input
          className="form-control"
          defaultValue={fields.name}
          {...register(`${formname}.name`, { 
            required: 'This is required',
            maxLength: 32,
          })}
          maxLength={32}
          type="text"
        />
        {errors?.name?.message ? (
          <div className="text-danger font-weight-bold">{errors?.name?.message}</div>
        ) : (
          (errors?.name?.type === 'maxLength') && (
            <div className="text-danger font-weight-bold">Name should not exceed 32 characters</div>
          )
        )}
      </label>

      <label className="p-3">
        <span className="text-left d-block mb-2">Type Of service*</span>
        <select
          className="form-control"
          defaultValue={fields.typeOfService}
          {...register(`${formname}.typeOfService`, {
            required: 'This is required',
          })}
        >
          <option value="">Select Any</option>
          {typeOfServiceOptions.map(({ value, text, disabled }) => (
            <option disabled={disabled} key={value} value={value}>
              {text}
            </option>
          ))}
        </select>
        {errors?.typeOfService && (
          <div className="text-danger font-weight-bold">{errors?.typeOfService?.message}</div>
        )}
      </label>

      <div className="h5 font-weight-bold w-100 col-12 px-3 pt-3">Service Address</div>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">Street Number*</span>
        <input
          className="form-control"
          defaultValue={fields.streetNum}
          {...register(`${formname}.streetNum`, {
            required: 'This is required',
            validate: value =>
              (value == '' || Number(value) ? true : false) || 'Invalid Street Number',
          })}
          type="text"
        />
        {errors?.streetNum && (
          <div className="text-danger font-weight-bold">{errors?.streetNum?.message}</div>
        )}
      </label>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">Street Pre-Direction</span>
        <select
          className="form-control"
          defaultValue={fields.streetPreDir}
          {...register(`${formname}.streetPreDir`)}
        >
          <option value="">Select Any</option>
          {streetDirOptions.map(({ value, text, disabled }) => (
            <option disabled={disabled} key={value} value={value}>
              {text}
            </option>
          ))}
        </select>
        {errors?.streetPreDir && (
          <div className="text-danger font-weight-bold">{errors?.name?.message}</div>
        )}
      </label>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">Street Name*</span>
        <input
          className="form-control"
          defaultValue={fields.streetName}
          {...register(`${formname}.streetName`, { required: 'This is required' })}
          type="text"
        />
        {errors?.streetName && (
          <div className="text-danger font-weight-bold">{errors?.streetName?.message}</div>
        )}
      </label>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">Street Type</span>
        <input
          className="form-control"
          defaultValue={fields.streetType}
          {...register(`${formname}.streetType`)}
          type="text"
        />
        {errors?.streetType && (
          <div className="text-danger font-weight-bold">{errors?.streetType?.message}</div>
        )}
      </label>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">Street Post-Direction</span>
        <select
          className="form-control"
          defaultValue={fields.streetPostDir}
          {...register(`${formname}.streetPostDir`)}
        >
          <option value="">Select Any</option>
          {streetDirOptions.map(({ value, text, disabled }) => (
            <option disabled={disabled} key={value} value={value}>
              {text}
            </option>
          ))}
        </select>
        {errors?.streetPostDir && (
          <div className="text-danger font-weight-bold">{errors?.streetPostDir?.message}</div>
        )}
      </label>

      <LocationForm arrayName="locations" formname={formname} form={form} />

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">Country*</span>
        <select
          className="form-control"
          defaultValue={fields.country}
          type="text"
          onChange={handleSelectCountry}
        >
          <option value="">Select Any</option>
          {COUNTRY_LIST.map(country => (
            <option key={country} value={country}>
              {country}
            </option>
          ))}
        </select>
      </label>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">City*</span>
        <input
          className="form-control"
          defaultValue={fields.city}
          {...register(`${formname}.city`, { required: 'This is required' })}
          type="text"
        />
        {errors?.city && (
          <div className="text-danger font-weight-bold">{errors?.city?.message}</div>
        )}
      </label>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">{stateOrProvince?.label1}*</span>
        <select
          className="form-control"
          defaultValue={fields.state}
          {...register(`${formname}.state`, { required: 'This is required' })}
          type="text"
        >
          <option value="">Select Any</option>
          {stateOrProvince?.value?.map(state => (
            <option key={state.value} value={state.value}>
              {state.label}
            </option>
          ))}
        </select>
      </label>

      <label className="p-3">
        <span className="font-weight-bolder text-left d-block mb-2">{stateOrProvince?.label2}*</span>
        <input
          className="form-control"
          defaultValue={fields.postalCode}
          {...register(`${formname}.postalCode`, {
            required: 'This is required',
            minLength: 5,
            maxLength: 10,
            validate: value => ( stateOrProvince?.label2 === 'Zip Code' ? isValidUSZIPCode(value) : isValidCanadianProvince(value) ) || `Invalid ${stateOrProvince?.label2}`,
          })}
          type="text"
        />
        {errors?.postalCode?.message ? (
          <div className="text-danger font-weight-bold">{errors?.postalCode?.message}</div>
        ) : (
          (errors?.postalCode?.type === 'maxLength' ||
            errors?.postalCode?.type === 'minLength') && (
            <div className="text-danger font-weight-bold">Please enter correct {stateOrProvince?.label2}</div>
          )
        )}
      </label>

      {!id && (
        <div className="w-100 col-12 px-3 pt-3">
          <div>In the box below, click to select Telephone Numbers targeted by the data above.</div>
          <div>
            To select, click and drag across numbers, or use <kbd>Shift</kbd> or
            <kbd>Ctrl</kbd>
          </div>
          <div className="my-3">
            <div>
              <div className="my-1 d-inline-flex align-items-baseline">
                <textarea
                  rows={1}
                  placeholder="Enter Number To add"
                  className="form-control"
                  type="number"
                  className="form-control mr-2"
                  ref={numberaddinputref}
                />
              </div>
              <Button
                type="button"
                color="primary"
                className="btn-sm mr-2"
                onClick={() => setValue(`${formname}.tn`, tnOptions)}
              >
                Select All
              </Button>
              <Button
                type="button"
                color="primary"
                className="btn-sm mr-2"
                onClick={() => setValue(`${formname}.tn`, undefined)}
              >
                Select None
              </Button>
            </div>
          </div>
          <select
            size="10"
            className="form-control w-auto"
            multiple
            defaultValue={fields.tn}
            {...register(`${formname}.tn`, { required: 'This is required' })}
            onChange={e => {
              const result = [];
              Array.prototype.forEach.call(e.target.options || [], opt => {
                if (opt.selected) result.push(opt.value);
              });
              setValue(`${formname}.tn`, result);
            }}
          >
            {tnOptions.map(num => (
              <option key={num} selected={fields?.tn?.includes(parseInt(num))} value={num}>
                {num}
              </option>
            ))}
          </select>
          {errors?.tn && <div className="text-danger font-weight-bold">{errors?.tn?.message}</div>}
        </div>
      )}
    </div>
  );
}
